/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <Articles {...cmsData} />)
 * and then make these props fit the final module.
 *
 * Note that propTypes are not needed in this component: the GraphQL schema
 * definition is sufficient for that matter.
 */
import React from "react"
import { Articles as ArticlesModule } from "@bw/modules"
import { useStaticQuery, graphql } from "gatsby"

const Articles = () => {
  const { articles, categories } = useStaticQuery(graphql`query articlesModulesQuery {
  categories: allTaxonomyCategory(
    filter: {entries_count: {gt: 0}}
    sort: {title: ASC}
  ) {
    nodes {
      title
      slug
    }
  }
  articles: allCollectionArticles {
    nodes {
      title
      slug
      date
      teaserExcerpt
      category {
        slug
      }
      teaserImage {
        localImage {
          childImageSharp {
            gatsbyImageData(width: 350, height: 175)
          }
        }
      }
    }
  }
}`)

  return (
    <ArticlesModule categories={categories.nodes} articles={articles.nodes} />
  )
}

export { Articles }
